// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__281IB","content":"styles_content__3K27Q"};